module.exports = __webpack_public_path__ + "static/media/stern.4986ccc5.png";